import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { CountSchema, DecimalSchema } from '../property.models.ts'
import { TeamIdSchema } from '../unique-id.models.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const LegacyQuickframeMakerRatingResponsesSchema = z.object({
  projectsRated: CountSchema,
  experienceRating: DecimalSchema(2),
  qualityRating: DecimalSchema(2),
})

export type LegacyQuickframeMakerRatingResponses = ZodSimplify<
  typeof LegacyQuickframeMakerRatingResponsesSchema
>

export const LegacyQuickframeMakerRatingSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract(['legacy-quickframe-maker-rating']),
  agencyTeamId: TeamIdSchema,
  responses: LegacyQuickframeMakerRatingResponsesSchema,
})
